module.exports = __webpack_public_path__ + "img/nev-logo.1942bc8f.png";